import './_product-quick-add-card.scss';
import component from './product-quick-add-card';

export default component;
